"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var create_form_template_html_1 = __importDefault(require("./create-form-template.html"));
var create_form_template_controller_1 = __importDefault(require("./create-form-template.controller"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.formtemplates.create", {
        url: "/form-templates/create",
        controller: "AdminCreateFormTemplateController",
        controllerAs: "vm",
        template: create_form_template_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.formtemplates.createformtemplate", [])
    .config(config)
    .controller("AdminCreateFormTemplateController", create_form_template_controller_1.default);
